var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16203 5.47363H0.265625V14.8582H3.16203V5.47363Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71367 4.24394C2.05634 4.24704 2.3922 4.14801 2.67862 3.95944C2.96504 3.77086 3.18911 3.50122 3.32239 3.18476C3.45567 2.8683 3.49216 2.51928 3.42721 2.182C3.36226 1.84472 3.1988 1.53438 2.95759 1.29039C2.71638 1.04639 2.4083 0.879735 2.07243 0.811571C1.73657 0.743407 1.38808 0.776811 1.07119 0.907539C0.754296 1.03827 0.483293 1.26043 0.29258 1.54582C0.101867 1.83122 3.17528e-05 2.16697 1.77835e-05 2.51048C-0.00100978 2.73709 0.0425033 2.96169 0.128067 3.17145C0.21363 3.3812 0.339576 3.57202 0.498704 3.73298C0.657831 3.89395 0.847022 4.02192 1.05549 4.10959C1.26395 4.19726 1.48761 4.24291 1.71367 4.24394Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79102 9.93089C7.79102 8.61204 8.39997 7.82542 9.55932 7.82542C10.625 7.82542 11.1207 8.58073 11.1207 9.93089V14.8541H14.0015V8.91338C14.0015 6.40091 12.5806 5.18381 10.5977 5.18381C10.0323 5.17726 9.47489 5.3181 8.98014 5.59252C8.48539 5.86694 8.07025 6.26552 7.7754 6.74921V5.48515H4.99609V14.8776H7.7754L7.79102 9.93089Z",
    fill: "#263238"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/linkedIn-logo.51ce7688a809585a8302523497f022a0.svg";
export { ForwardRef as ReactComponent };